import { WithStoryProps } from '@storyofams/storyblok-toolkit';
import { format } from 'date-fns';
import SbEditable from 'storyblok-react';

import { GuidechapterItems } from '~/graphql/sdk';
import { classNames } from '~/lib';
import { DynamicPage } from '..';
import { BannerDynamic } from '../Banners/BannerDynamic';
import { HeaderSimple } from '../Blocks/HeaderSimple';
import { Share } from '../Share';
import { PageNavigation } from '.';
import { ChapterNav } from './ChapterNav';

export interface GuideChapterPageProps extends WithStoryProps {
  guideChapters: GuidechapterItems;
}

export const GuideChapterPage = ({
  story,
  guideChapters,
}: GuideChapterPageProps) => {
  const currentIndex = guideChapters?.items?.findIndex(
    (chapter) => chapter?.uuid === story?.uuid,
  );

  const guideIndex = {
    content: { title: 'Guide Index' },
    full_slug: `${guideChapters?.items[0]?.full_slug?.split('/')[1]}`,
  };

  const previous =
    currentIndex === 0 ? guideIndex : guideChapters?.items[currentIndex - 1];

  const next = guideChapters?.items[currentIndex + 1];

  return (
    <div>
      <ChapterNav guideChapters={guideChapters} currentIndex={currentIndex} />

      {story?.content?.title && (
        <HeaderSimple
          first
          overviewLink={`/${guideIndex?.full_slug}`}
          overviewText="Back to guide index"
          subtext={
            !!story?.published_at
              ? `Last updated: ${format(
                  new Date(story?.published_at),
                  'dd MMMM yyyy',
                )}`
              : ''
          }
          content={{
            title: story?.content?.title,
            description: story?.content?.subtitle,
          }}
        />
      )}

      <div className="md:px-0">
        <DynamicPage story={story} className="lg:pb-16" />
      </div>

      <div className="max-w-5xl mx-auto px-4 lg:px-28">
        <div className="lg:px-2.5">
          <PageNavigation previous={previous} next={next} />
        </div>
      </div>

      <div className="flex flex-col items-center justify-center mt-24 lg:mt-28">
        <Share title="sharing" center />
      </div>

      {story?.content?.banner?.content && (
        <SbEditable content={story.content.banner.content}>
          <div
            className={classNames(
              'w-full max-w-6xl mx-auto px-4 md:px-5 pt-0 lg:pt-0 lg:max-w-6xl mt-32 lg:mt-36',
            )}
          >
            <BannerDynamic content={story.content.banner?.content} />
          </div>
        </SbEditable>
      )}
    </div>
  );
};
